import { config } from '@/config/app.config';

const description =
  "Know what to expect before and after a company's earnings release with WhatIF: Earnings. Understand how beats and misses impact your stocks.";
const title = 'WhatIF - Earnings';

export const searchSeo = {
  title,
  url: `${config.urls.website}/earnings`,
  description,
  og: {
    description,
    image: `${config.urls.website}/earnings/images/whatif-earnings-search.png`,
    title,
    imageAlt: title,
  },
};
